import { ethers } from "ethers";

export function formatAssetAmountForMessage(
  valueRaw: bigint,
  decimals: number,
): string {
  const formatted = ethers.formatUnits(valueRaw, decimals);
  if (!formatted.includes(".")) return formatted;
  const trimmed = formatted.replace(/0+$/, "").replace(/\.$/, "");
  return trimmed || "0";
}

export function buildInsufficientVaultAssetMessage({
  requestedRaw,
  availableRaw,
  decimals,
  symbol,
}: {
  requestedRaw: bigint;
  availableRaw: bigint;
  decimals: number;
  symbol: string;
}): string {
  const requested = formatAssetAmountForMessage(requestedRaw, decimals);
  const available = formatAssetAmountForMessage(availableRaw, decimals);
  return `Insufficient vault ${symbol}: withdraw requires ${requested} ${symbol}, available ${available} ${symbol}. Lower the amount or fund the vault first.`;
}

export function getVaultWithdrawInsufficiencyMessage({
  requestedRaw,
  availableRaw,
  decimals,
  symbol,
}: {
  requestedRaw: bigint;
  availableRaw: bigint | null;
  decimals: number;
  symbol: string;
}): string | null {
  if (availableRaw == null || requestedRaw <= 0n) return null;
  if (requestedRaw <= availableRaw) return null;
  return buildInsufficientVaultAssetMessage({
    requestedRaw,
    availableRaw,
    decimals,
    symbol,
  });
}
